import React from "react";

// Converte un indice colonna 0-based in lettere stile Excel (0->A, 25->Z,
// 26->AA...). Usata solo per l'intestazione della griglia qui sotto.
function letteraColonna(indice) {
  let n = indice + 1;
  let s = "";
  while (n > 0) {
    const resto = (n - 1) % 26;
    s = String.fromCharCode(65 + resto) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}

// Un file cliente "ibrido" (Excel con layout da PDF, vedi routes/api.js
// zonaMetadata) tiene spesso metadata dell'intero ordine — numero PO, date,
// mittente — in celle sparse sopra la vera tabella dati, non in una colonna.
// Per un campo di mapping di tipo "cella" (routes/ordini.js leggiCella)
// questa modale mostra quella zona come griglia cliccabile: un click su una
// cella sceglie il riferimento A1 (es. "C2") invece di doverlo scrivere a
// mano indovinando riga/colonna. Stesso linguaggio visivo di
// SceltaIntestazioneModal.
export default function SceltaCellaModal({ nomeFile, zonaMetadata, onScegli, onAnnulla }) {
  const numeroColonne = Math.max(...zonaMetadata.map((r) => r.length), 1);
  const indici = Array.from({ length: numeroColonne }, (_, i) => i);

  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onAnnulla}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "760px", maxWidth: "94vw", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>📍</span>
            <div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
                Scegli la cella
              </div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontSize: "11px", color: "var(--cf-text-faint)", letterSpacing: "0.3px", marginTop: "3px" }}>
                {nomeFile}
              </div>
            </div>
          </div>
          <button className="cf-btn" onClick={onAnnulla} style={{ border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "24px", overflowY: "auto" }}>
          <p className="testo-secondario" style={{ marginTop: 0 }}>
            Queste sono le righe sopra l'intestazione della tabella (es. numero ordine, date, mittente). Clicca sulla
            cella che contiene il valore da usare — resterà uguale per tutte le righe generate.
          </p>
          <div className="scroll-orizzontale">
            <table className="tabella-anteprima">
              <thead>
                <tr>
                  <th></th>
                  {indici.map((j) => <th key={j} style={{ textAlign: "center" }}>{letteraColonna(j)}</th>)}
                </tr>
              </thead>
              <tbody>
                {zonaMetadata.map((riga, i) => (
                  <tr key={i}>
                    <td style={{ whiteSpace: "nowrap", fontWeight: 600, color: "var(--cf-text-faint)" }}>{i + 1}</td>
                    {indici.map((j) => {
                      const valore = riga[j];
                      const vuota = valore === null || valore === undefined || String(valore).trim() === "";
                      return (
                        <td
                          key={j}
                          onClick={() => { if (!vuota) onScegli(`${letteraColonna(j)}${i + 1}`, String(valore)); }}
                          style={{
                            cursor: vuota ? "default" : "pointer",
                            color: vuota ? "var(--cf-text-faint)" : undefined,
                          }}
                          title={vuota ? undefined : `Usa "${valore}"`}
                          onMouseEnter={(e) => { if (!vuota) e.currentTarget.style.backgroundColor = "rgba(30, 58, 138, 0.15)"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = ""; }}
                        >
                          {vuota ? "" : String(valore)}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div style={{ padding: "16px 24px", borderTop: "1px solid var(--cf-border)", display: "flex", justifyContent: "flex-end", gap: "10px", flexShrink: 0 }}>
          <button onClick={onAnnulla}>Annulla</button>
        </div>
      </div>
    </div>
  );
}
